import apollo from "./apollo"

export default {
  apollo,
}
